<script>
    import Layout from "../../layouts/main";
    import PageHeader from "@/components/page-header";
    import appConfig from "@/app.config";
    import Loader from "@/components/widgets/preloader";
    import { mapGetters,mapActions,mapState } from "vuex"
    import moment from "moment";
    import { ModelListSelect } from "vue-search-select";
    
    /**
     * Advanced table component
     */
    export default {
      page: {
        title: "Monthly Profits Analysis Report",
        meta: [
          {
            name: "description",
            content: appConfig.description,
          },
        ],
      },
      components: {
        Layout,
        PageHeader,
        Loader,
        ModelListSelect,
      },
      data() {
        return {
          total_amount: 0,
          total_paid: 0,
          filterSales:{
            // month: this.currentdate.getMonth(),
            month: moment().month(),
            year: moment().year()
          },
          currentdate: moment(new Date()).format("YYYY-MM-DD"),
          title: "Monthly Profits Analysis Report",
          items: [
            {
              text: "Home",
              href: "/",
            },
            {
              text: "Monthly Profits Analysis Report",
              active: true,
            },
          ],
          totalRows: 1,
    
          currentPage: 1,
          perPage: 10,
          pageOptions: [10, 25, 50, 100, 200, 1000],
          filter: null,
          todoFilter: null,
          filterOn: [],
          todofilterOn: [],
          sortDesc: false,
          modal_id: "",
          monthfields: [
            {
              key: "index",
              sortable: true,
              label: "S/N",
            },
            {
              key: "month",
              sortable: true,
              label: 'MONTH',
            },
            {
              key: "date",
              sortable: true,
              label: 'DATE',
            },
            {
              key: "profit",
              sortable: true,
              label: 'TOTAL PROFITS',
            },
            {
              key: "details",
              sortable: true,
              label: "DETAILS",
            }
          ],
          Months: [
            { id: 12, text:"All Months"},
            { id: 0, text:"January"},
            { id: 1, text:"February"},
            { id: 2, text:"March"},
            { id: 3, text:"April"},
            { id: 4, text:"May"},
            { id: 5, text:"June"},
            { id: 6, text:"July"},
            { id: 7, text:"August"},
            { id: 8, text:"September"},
            { id: 9, text:"October"},
            { id: 10, text:"November"},
            { id: 11, text:"December"},
          ],
          annual:{
            jansales:0,
            febsales:0,
            marchsales:0,
            aprilsales:0,
            maysales:0,
            junesales:0,
            julysales:0,
            augsales:0,
            sepsales:0,
            octsales:0,
            novsales:0,
            decsales:0,
            total:0,
          }
        };
      },
      computed: {
             // MAP STATE
        ...mapState("notification", [
          "type",
          "message",
          "show",
          ]),
        ...mapGetters("sales", ["filterStatus","MonthlyProfitsAnalysis"]),
        ...mapGetters("users", ["Users"]),
        ...mapGetters("auth", ["business","branch"]),
        ...mapGetters("setting", ["GeneralSettings"]),
    
        /**
         * Total no. of records
         */
    
        rows() {
          return this.MonthlyProfitsAnalysis ? this.MonthlyProfitsAnalysis.length : 1;
        },
    
        /**
         * Todo list of records
         */
      },
      mounted() {
        // Set the initial number of items
        this.totalRows = this.MonthlyProfitsAnalysis ? this.MonthlyProfitsAnalysis.length : 1;
      },  
      methods: {
        ...mapActions({
          FetchMonthlyProfitsAnalysis: "sales/fetchMonthlyProfits",   
          FetchGeneralSettings: "setting/fetchGeneralSettings", 
        }),
    
        // COMMA SEPERATORS
        thousandSeperator(m) {
          if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
            return m
                .toString()
                .replace(/[^0-9.]+/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          } else {
            return m;
          }
        },
    
        ProfitsAnalysisData() {
          this.FetchMonthlyProfitsAnalysis(this.filterSales);
          
        },
        /**
         * Search the table data with search input
         */
        onFiltered(filteredItems) {
          // Trigger pagination to update the number of buttons/pages due to filtering
          this.totalRows = filteredItems.length;
          this.currentPage = 1;
        },
      },
      updated() {
        let total_amount = 0;        
          if(this.MonthlyProfitsAnalysis && this.filterSales.month != 12){
            this.MonthlyProfitsAnalysis.forEach((item)=>{
              total_amount = total_amount+parseInt(item.amount-(item.buyingamount+item.discounts));
            });
            this.total_amount = total_amount;
          }         
      },
      watch: {
        MonthlyProfitsAnalysis(newValue){
          let total = 0;
          if(newValue == true){
            this.ProfitsAnalysisData();
          } 
          if(newValue && this.filterSales.month == 12){
            this.MonthlyProfitsAnalysis.forEach((item)=>{
              total = total+parseInt(item.profit);
            this.annual.total = total;
              if(item.salemonth == 1){
                this.annual.jansales = this.annual.jansales+item.profit;
              }else if(item.salemonth == 2){
                this.annual.febsales = this.annual.febsales+item.profit;
              }else if(item.salemonth == 3){
                this.annual.marchsales = this.annual.marchsales+item.profit;
              }else if(item.salemonth == 4){
                this.annual.aprilsales = this.annual.aprilsales+item.profit;
              }else if(item.salemonth == 5){
                this.annual.maysales = this.annual.maysales+item.profit;
              }else if(item.salemonth == 6){
                this.annual.junesales = this.annual.junesales+item.profit;
              }else if(item.salemonth == 7){
                this.annual.julysales = this.annual.julysales+item.profit;
              }else if(item.salemonth == 8){
                this.annual.augsales = this.annual.augsales+item.profit;
              }else if(item.salemonth == 9){
                this.annual.sepsales = this.annual.sepsales+item.profit;
              }else if(item.salemonth == 10){
                this.annual.octsales = this.annual.octsales+item.profit;
              }else if(item.salemonth == 11){
                this.annual.novsales = this.annual.novsales+item.profit;
              }else if(item.salemonth == 12){
                this.annual.decsales = this.annual.decsales+item.profit;
              }else if(!item.salemonth){
                this.annual.novsales = 0;
              }
            });
          }           
        }
      },
      created() {
       this.ProfitsAnalysisData();
       this.FetchMonthlyProfitsAnalysis(this.filterSales);
       this.FetchGeneralSettings();
      },
    };
    </script>
    
    <template>
      <Layout>
        <PageHeader :title="title" :items="items" />
    
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-body">
                <div class="row">
                  <div class="col-md-9">
                    <h3 class="card-title mb-2 text-center">Monthly Profits Analysis Report</h3>
                  </div>
                </div>  
                <div class="row">                                  
                  <div class="col-md-3 form-group">
                    <label>MONTH</label>
                    
                    <model-list-select
                      :list="Months ? Months : []"
                      v-model="filterSales.month"
                      option-value="id"
                      option-text="text"
                      placeholder="Select Month"
                      @input="ProfitsAnalysisData()"
                    >
                    </model-list-select>
                  </div>
                  <div class="col-md-3 form-group">
                    <label>YEAR</label>
                    
                    <input
                      v-model="filterSales.year"
                      placeholder="Enter Year"
                      class="form-control"
                    />
                  </div>
                  <div class="col-md-2 mt-4">
                  <button class="btn btn-primary" type="button" @click="ProfitsAnalysisData()">
                    <span class="fa fa-filter"></span> Filter
                    <b-spinner
                      v-show="filterStatus"
                      variant="light"
                      small
                      role="status"
                    ></b-spinner>
                  </button>
                </div>
                </div>            
                <div class="row mt-2">
                  <div class="col-sm-12 col-md-6">
                    <div id="tickets-table_length" class="dataTables_length">
                      <label class="d-inline-flex align-items-center">
                        Show&nbsp;
                        <b-form-select
                            class="form-select form-select-sm"
                            v-model="perPage"
                            size="sm"
                            :options="pageOptions"
                        ></b-form-select
                        >&nbsp;entries
                      </label>
                    </div>
                  </div>
                  <!-- Search -->
                  <div class="col-sm-12 col-md-6">
                    <div
                        id="tickets-table_filter"
                        class="dataTables_filter text-md-end"
                    >
                      <label class="d-inline-flex align-items-center">
                        Search:
                        <b-form-input
                            v-model="filter"
                            type="search"
                            placeholder="Search..."
                            class="form-control form-control-sm ms-2"
                        ></b-form-input>
                      </label>
                    </div>
                  </div>
                  <!-- End search -->
                </div>
                <!-- Table -->
                <div class="table-responsive mb-0" v-if="filterSales.month != 12">
                  <b-table
                      class="datatables"
                      :items="MonthlyProfitsAnalysis?MonthlyProfitsAnalysis:[]"
                      :fields="monthfields"
                      responsive="sm"
                      :per-page="perPage"
                      :current-page="currentPage"
                      :sort-desc.sync="sortDesc"
                      :filter="filter"
                      :filter-included-fields="filterOn"
                      @filtered="onFiltered"
                  >
                    <template #cell(index)="data">
                      {{ data.index + 1 }}
                    </template> 
                    <template #cell(month)="data">
                      <p v-if="filterSales.month == 0">{{ 'January' }}</p>
                      <p v-if="filterSales.month == 1">{{ 'February' }}</p>
                      <p v-if="filterSales.month == 2">{{ 'March' }}</p>
                      <p v-if="filterSales.month == 3">{{ 'April' }}</p>
                      <p v-if="filterSales.month == 4">{{ 'May' }}</p>
                      <p v-if="filterSales.month == 5">{{ 'June' }}</p>
                      <p v-if="filterSales.month == 6">{{ 'July' }}</p>
                      <p v-if="filterSales.month == 7">{{ 'August' }}</p>
                      <p v-if="filterSales.month == 8">{{ 'September' }}</p>
                      <p v-if="filterSales.month == 9">{{ 'October' }}</p>
                      <p v-if="filterSales.month == 10">{{ 'November' }}</p>
                      <p v-if="filterSales.month == 11">{{ 'December' }}</p>
                    </template> 
                    <template #cell(profit)="data">
                      {{ (data.item.amount - (data.item.buyingamount+data.item.discounts)).toLocaleString() }}
                    </template>   
                    <template #cell(details)="data">
                      <router-link
                          :to="{
                            name: 'Monthly Profits Details',
                            params: { date: data.item.date, period: filterSales.month },
                          }">
                        <b-button variant="info" class="btn btn-sm">Details</b-button>
                      </router-link>
                    </template>
                  </b-table>
                  <div class="row">                                      
                      <div class="col-md-4"></div>
                      <div class="col-md-4">
                        <h5>Total Amount: <span class="text-danger">{{(total_amount).toLocaleString()}}</span></h5>
                      </div>
                    </div>
                </div>                 
                
                <div v-else>
                  <table class="table-responsive mb-0 table" align="center">
                    <thead>
                      <tr>
                        <th>MONTH</th>
                        <th>TOTAL PROFITS</th>
                        <th>DETAILS</th>
                      </tr>                      
                    </thead>  
                    <tbody>
                      <tr v-if="annual.jansales != 0">
                        <td>January</td>
                        <td>{{annual.jansales.toLocaleString()}}</td>
                        <td>
                          <router-link
                              :to="{
                                name: 'Monthly Profits Details',
                                params: { date: 1, period: filterSales.month },
                              }">
                            <b-button variant="info" class="btn btn-sm">Details</b-button>
                          </router-link>
                        </td>
                      </tr>
                      <tr v-if="annual.febsales != 0">
                        <td>February</td>
                        <td>{{annual.febsales.toLocaleString()}}</td>
                        <td>
                          <router-link
                              :to="{
                                name: 'Monthly Profits Details',
                                params: { date: 2, period: filterSales.month },
                              }">
                            <b-button variant="info" class="btn btn-sm">Details</b-button>
                          </router-link>
                        </td>
                      </tr>
                      <tr v-if="annual.marchsales != 0">
                        <td>March</td>
                        <td>{{annual.marchsales.toLocaleString()}}</td>
                        <td>
                          <router-link
                              :to="{
                                name: 'Monthly Profits Details',
                                params: { date: 3, period: filterSales.month },
                              }">
                            <b-button variant="info" class="btn btn-sm">Details</b-button>
                          </router-link>
                        </td>
                      </tr>
                      <tr v-if="annual.aprilsales != 0">
                        <td>April</td>
                        <td>{{annual.aprilsales.toLocaleString()}}</td>
                        <td>
                          <router-link
                              :to="{
                                name: 'Monthly Profits Details',
                                params: { date: 4, period: filterSales.month },
                              }">
                            <b-button variant="info" class="btn btn-sm">Details</b-button>
                          </router-link>
                        </td>
                      </tr>
                      <tr v-if="annual.maysales != 0">
                        <td>May</td>
                        <td>{{annual.maysales.toLocaleString()}}</td>
                        <td>
                          <router-link
                              :to="{
                                name: 'Monthly Profits Details',
                                params: { date: 5, period: filterSales.month },
                              }">
                            <b-button variant="info" class="btn btn-sm">Details</b-button>
                          </router-link>
                        </td>
                      </tr>
                      <tr v-if="annual.junesales != 0">
                        <td>June</td>
                        <td>{{annual.junesales.toLocaleString()}}</td>
                        <td>
                          <router-link
                              :to="{
                                name: 'Monthly Profits Details',
                                params: { date: 6, period: filterSales.month },
                              }">
                            <b-button variant="info" class="btn btn-sm">Details</b-button>
                          </router-link>
                        </td>
                      </tr>
                      <tr v-if="annual.julysales != 0">
                        <td>July</td>
                        <td>{{annual.julysales.toLocaleString()}}</td>
                        <td>
                          <router-link
                              :to="{
                                name: 'Monthly Profits Details',
                                params: { date: 7, period: filterSales.month },
                              }">
                            <b-button variant="info" class="btn btn-sm">Details</b-button>
                          </router-link>
                        </td>
                      </tr>
                      <tr v-if="annual.augsales != 0">
                        <td>August</td>
                        <td>{{annual.augsales.toLocaleString()}}</td>
                        <td>
                          <router-link
                              :to="{
                                name: 'Monthly Profits Details',
                                params: { date: 8, period: filterSales.month },
                              }">
                            <b-button variant="info" class="btn btn-sm">Details</b-button>
                          </router-link>
                        </td>
                      </tr>
                      <tr v-if="annual.sepsales != 0">
                        <td>September</td>
                        <td>{{annual.sepsales.toLocaleString()}}</td>
                        <td>
                          <router-link
                              :to="{
                                name: 'Monthly Profits Details',
                                params: { date: 9, period: filterSales.month },
                              }">
                            <b-button variant="info" class="btn btn-sm">Details</b-button>
                          </router-link>
                        </td>
                      </tr>
                      <tr v-if="annual.octsales != 0">
                        <td>October</td>
                        <td>{{annual.octsales.toLocaleString()}}</td>
                        <td>
                          <router-link
                              :to="{
                                name: 'Monthly Profits Details',
                                params: { date: 10, period: filterSales.month },
                              }">
                            <b-button variant="info" class="btn btn-sm">Details</b-button>
                          </router-link>
                        </td>
                      </tr>
                      <tr v-if="annual.novsales != 0">
                        <td>November</td>
                        <td>{{annual.novsales.toLocaleString()}}</td>
                        <td>
                          <router-link
                              :to="{
                                name: 'Monthly Profits Details',
                                params: { date: 11, period: filterSales.month },
                              }">
                            <b-button variant="info" class="btn btn-sm">Details</b-button>
                          </router-link>
                        </td>
                      </tr>
                      <tr v-if="annual.decsales != 0">
                        <td>December</td>
                        <td>{{annual.decsales.toLocaleString()}}</td>
                        <td>
                          <router-link
                              :to="{
                                name: 'Monthly Profits Details',
                                params: { date: 12, period: filterSales.month },
                              }">
                            <b-button variant="info" class="btn btn-sm">Details</b-button>
                          </router-link>
                        </td>
                      </tr>
                    </tbody>  
                    <div class="row text-center">
                      <b><h5>Grand Total: {{annual.total.toLocaleString()}}</h5></b>
                    </div>       
                  </table>
                </div>
                <Loader  v-if="!MonthlyProfitsAnalysis"/>
                <div class="row">
                  <div class="col">
                    <div
                        class="dataTables_paginate paging_simple_numbers float-end"
                    >
                      <ul class="pagination pagination-rounded mb-0">
                        <!-- pagination -->
                        <b-pagination
                            v-model="currentPage"
                            :total-rows="rows"
                            :per-page="perPage"
                        ></b-pagination>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </template>
    
    <style>
    .btn-primary,.page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
    </style>
    